// 1. Your Data Source
const videos = {
  news:    ['Lh0D3W9eiSs', 'kseYcBtYq9c', 'eQHW0Dq6Pzg', 'A7qSB0Wn0cM'],
};

// 2. Password Generator Core Function
function generateSecurePassword(length = 16) {
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const numbers   = "0123456789";
  const symbols   = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
  
  const allChars = uppercase + lowercase + numbers + symbols;
  let password = "";
  
  const randomValues = new Uint32Array(length);
  window.crypto.getRandomValues(randomValues);
  
  for (let i = 0; i < length; i++) {
    password += allChars[randomValues[i] % allChars.length];
  }
  
  return password;
}

// 3. The Video Card Upgraded Factory
async function createVideo(id) {
  const wrapper = document.createElement('div');
  wrapper.className = 'video-wrapper';

  let videoTitle = "Loading...";
  try {
    const response = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${id}&format=json`);
    const data = await response.json();
    videoTitle = data.title;
  } catch (e) {
    videoTitle = "Video Title"; 
  }

  const titleOverlay = document.createElement('div');
  titleOverlay.className = 'video-title-overlay';
  titleOverlay.innerText = videoTitle;

  const img = document.createElement('img');
  const highRes = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
  const lowRes = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

  img.src = highRes;

  const tester = new Image();
  tester.src = highRes;
  tester.onload = function() {
    if (tester.naturalHeight === 90) {
      img.src = lowRes;
    }
  };

  img.alt = videoTitle;
  img.loading = 'lazy';
  
  const playBtn = document.createElement('div');
  playBtn.className = 'play-button';

  wrapper.appendChild(img);
  wrapper.appendChild(titleOverlay); 
  wrapper.appendChild(playBtn);

  wrapper.onclick = function() {
    this.innerHTML = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
  };

  return wrapper;
}

// 4. Combined Execution Block (All-In-One)
document.addEventListener('DOMContentLoaded', async () => {
  
  // --- Step A: Set Up The Password Generator Field ---
  const passInput = document.getElementById('password_gen');
  if (passInput) {
    passInput.value = generateSecurePassword();
    passInput.readOnly = true; 
    
    passInput.addEventListener('click', () => {
      passInput.value = generateSecurePassword();
      navigator.clipboard.writeText(passInput.value);
    });
  }

  // --- Step B: Fire Off All Video Galleries in Parallel ---
  const generationPromises = Object.entries(videos).map(async ([section, ids]) => {
    const gallery = document.getElementById(`${section}-gallery`);
    if (!gallery) return;

    const videoElements = await Promise.all(ids.map(id => createVideo(id)));
    videoElements.forEach(element => gallery.appendChild(element));
  });

  await Promise.all(generationPromises);
});
